import { render, staticRenderFns } from "./fs-detail.vue?vue&type=template&id=29a28a52&scoped=true&"
import script from "./fs-detail.vue?vue&type=script&lang=js&"
export * from "./fs-detail.vue?vue&type=script&lang=js&"
import style0 from "./fs-detail.vue?vue&type=style&index=0&id=29a28a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a28a52",
  null
  
)

export default component.exports